import { render, staticRenderFns } from "./InAppPurchaseProductsTable.vue?vue&type=template&id=9275cc56"
import script from "./InAppPurchaseProductsTable.vue?vue&type=script&lang=js"
export * from "./InAppPurchaseProductsTable.vue?vue&type=script&lang=js"
import style0 from "./InAppPurchaseProductsTable.vue?vue&type=style&index=0&id=9275cc56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports